import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from '@angular/core';
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { CookiePolicyComponent } from "../../modalDialogs/cookiePolicy/cookiePolicy.component"
import { cookieVersion } from "../../modalDialogs/cookiePolicy/cookiePolicy.component";
import { Router } from "@angular/router";
import { customConfig } from "../../../custom/custom-config";
import { CoreCOMService } from '../../services/com.service';
import { LocalKeys, StorageHive } from '../../services/valueStorage.service';
import { CoreLogService } from '../../services/log.service';
import { MetaPixelService } from '../../services/tracking/meta-pixel.service';
import { LanguageDialogComponent } from '../../modalDialogs';
import { Subscription } from 'rxjs';
import { CommunicationData } from '../../services/communicationdata.service';
import { ChefCampaignsService } from "../../services/ChefCampaignsService";

@Component({
  selector: 'cookiebanner',
  templateUrl: './cookiebanner.component.html',
  styleUrls: ['./cookiebanner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CookiebannerComponent implements OnInit {

  public isCookieBanner: boolean = true;
  public cookieBannerText: object;
  public selectableCookies: boolean;
  public currentLocale: string = "";
  private langSubscriber: Subscription;

  constructor(
    private _communicationData: CommunicationData,
    private _coreCOMService: CoreCOMService,
    private _coreLogService: CoreLogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _router: Router,
    private MetaPixelService: MetaPixelService,
    private _chefCampaingsService: ChefCampaignsService
  ) {
    const me = this;
    customConfig.meta_pixel !== "" ? me.selectableCookies = true : me.selectableCookies = false;
  }

  private PushChanges(): void {
    const me = this;
    try {
      me._changeDetectorRef.detectChanges();
    } catch (e) {
      me._coreLogService.error("CookiebannerComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.langSubscriber = me._communicationData.LanguageChoice().subscribe((languageChoice: string) => {
      me.currentLocale = languageChoice;
      me.PushChanges();
    });

    //Check if User accepted the cookie already
    me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.cookieConsent).then((cookieConsent) => {
      if (cookieConsent != null) {
        if (cookieConsent === cookieVersion) {
          me.isCookieBanner = false;
          me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.cookieConsentMeta).then((cookieConsentMeta) => {
            if (cookieConsentMeta) {
              me.MetaPixelService.load();
            } else {
              me.MetaPixelService.remove();
            }
          })
          me._chefCampaingsService.load();
          me.PushChanges();
        } else if (cookieConsent !== cookieVersion) {
          me._coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.cookieConsent)
          me._coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.cookieConsentMeta)
          me.PushChanges();
        }
      }
    }).catch(e => {
      me._coreLogService.error("CookiebannerComponent.ngOnit", "valueStorage.get cookieConsent", e);
    });
  }

  /**
   * accept all or essential cookies
   */
  public acceptCookies(hasSelectableCookies: boolean) {
    const me = this;
    me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.cookieConsent, cookieVersion).then(() => {
      if (hasSelectableCookies) {
        me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.cookieConsentMeta, hasSelectableCookies);
        me.MetaPixelService.load();
      }
      me.isCookieBanner = false;
      me.PushChanges();
    }).catch(e => {
      me._coreLogService.error("CookiebannerComponent.acceptCookie", "valueStorage.set cookieConsent", e);
    });
  }

  //open cookiepolicy dialog
  public openCookieDialog() {
    const me = this;
    const cookie_banner = me._bottomSheetHelperService.open(CookiePolicyComponent,
      me.isCookieBanner);
    cookie_banner.afterDismissed().subscribe((res: boolean) => {
      if (res === false) {
        me.isCookieBanner = false;
        me.PushChanges();
      }
      me.isCookieBanner = true;
    })
  }

  public openLanguageDialog(): void {
    const me = this;
    me._bottomSheetHelperService.open(LanguageDialogComponent);
  }

  public navigateToTerms(termID: number) {
    const me = this;
    me._router.navigate(["/termcondition", termID]);
  }

  ngOnDestroy(): void {
    const me = this;
    me.langSubscriber.unsubscribe();
  }
}
